<form *ngIf="invoiceForm" [formGroup]="invoiceForm" (ngSubmit)="onSubmit()" class="content-card" [hidden]="true">
  <mat-card class="form-card">
    <mat-card-content>
      <mat-form-field >
        <input matInput placeholder="Bill amount" formControlName="billAmount" readonly="true">
      </mat-form-field>
      <mat-form-field>
        <input matInput placeholder="Paid amount" formControlName="paidAmount" required  type="number">
      </mat-form-field>



    </mat-card-content>
    <mat-card-actions align="end">
      <button mat-raised-button color="accent" type="button" (click)="returnBack()">Cancel</button>
      <button mat-raised-button color="primary" type="submit"
          [disabled]="!invoiceForm.valid || invoiceForm.pristine">Save</button>
    </mat-card-actions>
  </mat-card>
</form>

<mat-card class="form-card content-card">
  <mat-card-content>
    <div [hidden]="!isInvoiceLoading">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
    <div *ngIf="invoice">

      <div style="color: red; margin-bottom: 10px; font-weight: bold; text-align: left;" *ngIf="invoice != null && invoice.debtorDistributionId != null && invoice.debtorDistribution != null && invoice.debtorDistribution.type == 'CashBro'">
        Invoice was transferred to CashBro
      </div>
      <div style="color: red; margin-bottom: 10px; font-weight: bold; text-align: left;" *ngIf="invoice != null && invoice.debtorDistributionId != null && invoice.debtorDistribution != null && invoice.debtorDistribution.type == 'Pair Finance'">
        Invoice was transferred to Pair Finance - current state: {{ invoice.paidStatePairFinance == null ? "unknown" : invoice.paidStatePairFinance }}
      </div>
      <h3>{{ invoice.code }}</h3>
      Bill amount: {{invoice.billAmount}}<br />
      Paid amount: {{invoice.paidAmount}}


    </div>

  </mat-card-content>
  <mat-card-actions align="end">
    <button mat-raised-button color="accent" type="button" (click)="returnBack()">Back</button>
  </mat-card-actions>
</mat-card>

<form *ngIf="paymentForm" [formGroup]="paymentForm" (ngSubmit)="onPaymentSubmit()" class="content-card">
  <mat-card class="form-card">
    <mat-card-content>

      <app-date-edit formControlName="date" placeholder="Date" required></app-date-edit>

      <mat-form-field>
        <input matInput placeholder="Amount" formControlName="amount" type="number" required>
      </mat-form-field>
    </mat-card-content>
    <mat-card-actions align="end">
      <button mat-raised-button color="accent" type="button" (click)="returnBack()">Cancel</button>
      <button mat-raised-button color="primary" type="submit"
              [disabled]="!paymentForm.valid || paymentForm.pristine">Save</button>
    </mat-card-actions>
  </mat-card>
</form>

<mat-card class="content-card form-card">
  <mat-card-content>
<h4>Payments</h4>

    <div [hidden]="!isLoadingPayments">
      <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
<div class="list-item" fxLayout="row" fxLayoutGap="10px" >
  <label fxFlex="20" class="secondary">Date</label>
  <label fxFlex="16" class="secondary">Amount</label>


</div>
<div id="scroll" [hidden]="isLoadingPayments">
  <div class="list-item" fxLayoutAlign="left center" fxLayout="row" fxLayoutGap="10px" *ngFor="let payment of payments" >
    <div class="" fxFlex="20" >{{ payment.date | date: "dd.MM.yyyy HH:mm" }}</div>
    <div class="" fxFlex="16" >{{ payment.amount }}</div>
    <div class="" fxFlex="10">
      <button mat-icon-button (click)="deletePayment(payment.id)">
        <mat-icon style="color: orangered;">delete</mat-icon>
      </button>
    </div>
  </div>
</div>
  </mat-card-content>
</mat-card>
